import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { useStores } from '@/hooks/use-stores';

import { EPInfoLockContainer, InfoIconWrapper } from './styled';
import EPTierTooltip from './EPTierTooltip';

type Props = {
  type: string;
  tooltipTitle?: string | React.ReactElement;
  tooltipPlacement?: string;
  tooltipWidth?: number;
  tooltipTextPart1?: string | React.ReactElement;
  tooltipTextPart2?: string | React.ReactElement;
  tooltipClickableText?: string;
  emailRequestTypeOfInterestedPackage?: string;
  emailRequestButtonClicked?: string;
  emailRequestWhichScreen?: string;
  customMessage?: string;
  className?: string;
  toolTipEnabled?: boolean;
};

const EPTierInfoIcon = observer(
  ({
    type,
    tooltipTitle,
    tooltipTextPart1,
    tooltipTextPart2,
    tooltipClickableText,
    tooltipPlacement,
    tooltipWidth,
    toolTipEnabled = true,
    emailRequestTypeOfInterestedPackage,
    emailRequestButtonClicked,
    emailRequestWhichScreen,
    customMessage,
    className,
  }: Props) => {
    const { stationStore } = useStores();
    const isNotCalculated = stationStore?.packageSensors?.includes(type);
    const [isTierRequestModalOpen, setIsTierRequestModalOpen] = useState(false);

    const onModalClose = () => {
      setIsTierRequestModalOpen(false);
    };

    if (isNotCalculated) {
      return null;
    }

    return (
      <EPInfoLockContainer className={className}>
        <EPTierTooltip
          title={tooltipTitle}
          textPart1={tooltipTextPart1}
          textPart2={tooltipTextPart2}
          clickableText={tooltipClickableText}
          tooltipPlacement={tooltipPlacement ?? 'bottom'}
          initialIsTierRequestModalOpen={isTierRequestModalOpen}
          tooltipWidth={tooltipWidth ?? 330}
          onModalCloseHandler={onModalClose}
          emailRequestTypeOfInterestedPackage={emailRequestTypeOfInterestedPackage}
          emailRequestButtonClicked={emailRequestButtonClicked}
          emailRequestWhichScreen={emailRequestWhichScreen}
          customMessage={customMessage}
          shouldShowTooltip={toolTipEnabled}
        >
          <InfoIconWrapper>
            <InfoCircleOutlined className="info-icon" />
          </InfoIconWrapper>
        </EPTierTooltip>
      </EPInfoLockContainer>
    );
  },
);

export default EPTierInfoIcon;
